import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../loader/loader.component';
import { KeyValuePipe } from '../keyValuePipe/key-value.pipe';
import { divLoaderComponent } from '../divLoader/divLoader.component';



@NgModule({
  providers:[],
  declarations: [LoaderComponent,KeyValuePipe,divLoaderComponent],
  imports: [
    CommonModule
  ],  
  exports: [LoaderComponent,KeyValuePipe,divLoaderComponent]
})
export class SharedModule { }
